/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/02/17
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { fetchReports } from 'actions/reportCreators';
import ListPageComponent from 'components/ListPage';
import { getReports, getReportsLoaded } from 'selectors/siteSelectors';

const mapStateToProps = (state) => {
  const loaded = getReportsLoaded(state);
  const reports = getReports(state);
  return {
    reports,
    loading: !loaded && reports.length === 0,
  };
};

const mapDispatchToProps = dispatch => ({
  handleMount: () => {
    dispatch(fetchReports());
    return setInterval(() => {
      dispatch(fetchReports());
    }, 5000);
  },
});

const ListPageContainer = connect(mapStateToProps, mapDispatchToProps)(ListPageComponent);

export default ListPageContainer;
